module.exports = __webpack_public_path__ + "img/second_bg.ec120e1e.png";